import clsx from "clsx"
import { differenceInCalendarDays } from "date-fns"
import { pluralize } from "utils/helpers"

interface CreditBannerProps {
  duration: string
}

const getCreditLabel = (
  duration: string
): { label: string | null; daysLeft: number | null } => {
  if (!duration) {
    return { label: null, daysLeft: null }
  }

  const expiry = new Date(duration)

  if (Number.isNaN(expiry.getTime())) {
    return { label: null, daysLeft: null }
  }

  const today = new Date()
  const daysLeft = Math.max(0, differenceInCalendarDays(expiry, today))

  if (daysLeft === 0) {
    return { label: "Today", daysLeft }
  }

  return {
    label: `in ${pluralize("day", daysLeft)}`,
    daysLeft,
  }
}

const CreditBanner: React.FC<CreditBannerProps> = ({ duration }) => {
  const { label, daysLeft } = getCreditLabel(duration)

  if (!label || daysLeft === null) {
    return null
  }

  const isLastDay = daysLeft === 0 || daysLeft === 1

  return (
    <div
      className={clsx(
        "flex w-fit items-center rounded-xl border p-1 shadow-sm",
        {
          "border-critical-400 bg-red-50": isLastDay,
          "border-highlight-300 bg-highlight-50": !isLastDay,
        }
      )}
    >
      <p
        className={clsx("text-sm font-medium", {
          "text-critical-600": isLastDay,
          "text-highlight-700": !isLastDay,
        })}
      >
        Locks <span className="font-semibold">{label}</span>
      </p>
    </div>
  )
}

export default CreditBanner
